import { useEffect } from 'react';
import { ButtonLink } from '@cuorum/ui';

export function NotFound({ title = 'No encontramos esta página', detail }: { title?: string; detail?: string }) {
  useEffect(() => { document.title = `${title} · Cuórum Eventos`; }, [title]);
  return (
    <main className="app-center">
      <h1 className="app-title">{title}</h1>
      <p className="app-muted">{detail ?? 'Puede que el enlace esté mal escrito o que el evento ya no esté publicado.'}</p>
      <ButtonLink href="/" variant="secondary">Ir al inicio</ButtonLink>
    </main>
  );
}
